import create from 'zustand';
import { ReportableType } from '../graphql/query/reportModeration.queries';

export type DateRangeType = 'today' | 'lastWeek' | 'lastMonth' | 'oldest' | null;

export interface ReportsFilters {
  dateRange: DateRangeType;
  contentTypes: ReportableType[];
}

interface ReportsStoreState {
  filters: ReportsFilters;
  setFilters: (filters: Partial<ReportsFilters>) => void;
  resetFilters: () => void;
}

export const useReportsStore = create<ReportsStoreState>((set) => ({
  filters: {
    dateRange: null,
    contentTypes: [],
  },
  setFilters: (newFilters) =>
    set((state) => ({
      filters: { ...state.filters, ...newFilters },
    })),
  resetFilters: () =>
    set({
      filters: {
        dateRange: null,
        contentTypes: [],
      },
    }),
}));